import gql from 'graphql-tag'

const TICKETING_TICKETS_REINDEX = gql`
  mutation ticketingTicketsReindex {
    ticketingTicketsReindex
  }
`

export { TICKETING_TICKETS_REINDEX }
